import i18n from '@/core/i18n';
import { CommonConstants } from '@/modules/common/constants/common.constants';
import { isNumber } from '@/utils/number/is-number';

export class RateMask {
  static apply(rate: number | undefined): string {
    if (rate && RateMask.isMasked(rate)) {
      return i18n.t('common:maskedRate');
    }
    return rate?.toString() ?? '';
  }

  static applyToString(rate: string | undefined): string {
    if (rate && isNumber(rate)) {
      return RateMask.apply(parseFloat(rate));
    }

    return rate?.toString() ?? '';
  }

  static isMasked(rate: number | undefined): boolean {
    return rate == CommonConstants.MASKED_RATE;
  }

  static isMaskedStringValue(rate: string | undefined): boolean {
    return rate != undefined && isNumber(rate) && parseFloat(rate) == CommonConstants.MASKED_RATE;
  }
}
